// selectHomeActivityItems.js

import { ACTIVITY_FEED_ITEM_KIND } from 'node/activity/utils/buildActivityFeedItems';
import { shouldShowHomeActivityItem } from 'home/activity/utils/homeActivityFilters';

export const HOME_FEED_COMMENT_LIMIT = 60;
export const HOME_FEED_SYSTEM_LIMIT = 20;

/**
 * Newest-first compare for Home feed rows.
 *
 * @param {object} left
 * @param {object} right
 * @returns {number}
 */
function sortNewest(left, right) {
  if (left.at !== right.at) return right.at - left.at;
  return String(left.key).localeCompare(String(right.key));
}

/**
 * Keep comments visible on Home even when newer field-change
 * events would otherwise crowd them out of a flat recency slice.
 *
 * @param {object[]} rows
 * @param {{ commentLimit?: number, systemLimit?: number, includeDetails?: boolean }} [options]
 * @returns {object[]}
 */
export function selectHomeActivityItems(rows, {
  commentLimit = HOME_FEED_COMMENT_LIMIT,
  systemLimit = HOME_FEED_SYSTEM_LIMIT,
  includeDetails = false,
} = {}) {
  const comments = [];
  const systems = [];

  (Array.isArray(rows) ? rows : []).forEach((row) => {
    if (!shouldShowHomeActivityItem(row, { includeDetails })) return;
    if (row.kind === ACTIVITY_FEED_ITEM_KIND.COMMENT) comments.push(row);
    else systems.push(row);
  });

  comments.sort(sortNewest);
  systems.sort(sortNewest);

  return [
    ...comments.slice(0, commentLimit),
    ...systems.slice(0, systemLimit),
  ].sort(sortNewest);
}
